import { render } from "./ProjectFinish.vue?vue&type=template&id=43227088&scoped=true&ts=true"
import script from "./ProjectFinish.ts?vue&type=script&lang=ts"
export * from "./ProjectFinish.ts?vue&type=script&lang=ts"

import "./ProjectFinish.scss?vue&type=style&index=0&id=43227088&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43227088"]])

export default __exports__